import React from 'react';
const MenuContext = React.createContext({
  showMobileMenu: false,
  openActiveSubmenus: false
});
export default MenuContext;
//# sourceMappingURL=MenuContext.js.map